import { OrgSdk } from 'lib-klab-sdks';

type WorkScheduleResponse = OrgSdk.WorkScheduleResponse;
type WorkScheduleCreateRequest = OrgSdk.WorkScheduleCreateRequest;
type WorkScheduleUpdateRequest = OrgSdk.WorkScheduleUpdateRequest;

type PageResponse = {
    number: number;
    size: number;
    totalElements: number;
    totalPages: number;
};

export const workSchedulesSdkMock = (() => {
    let nextScheduleId = 100;
    let nextWorkDayId = 1000;

    const schedules: WorkScheduleResponse[] = [
        {
            workScheduleId: 29,
            name: 'jojijiji',
            department: { departmentId: 70, name: 'depto 10' },
            status: 'ACTIVE',
            days: [
                { workDayId: 49, dayOfWeek: 'WEDNESDAY', startTime: '00:00', endTime: '10:00', breakTime: false, countBreakTime: 0 },
            ],
        } as any,

        {
            workScheduleId: 26,
            name: 'horario nuevo',
            department: { departmentId: 55, name: 'Finance v12' },
            status: 'ACTIVE',
            days: [
                { workDayId: 41, dayOfWeek: 'MONDAY', startTime: '00:00', endTime: '03:00', breakTime: false, countBreakTime: 0 },
                { workDayId: 50, dayOfWeek: 'TUESDAY', startTime: '02:10', endTime: '04:20', breakTime: false, countBreakTime: 0 },
            ],
        } as any,

        {
            workScheduleId: 22,
            name: 'Standard Shift Updated',
            department: { departmentId: 33, name: 'Human Resourcesv1postman' },
            status: 'ACTIVE',
            days: [
                { workDayId: 19, dayOfWeek: 'FRIDAY', startTime: '09:00', endTime: '18:00', breakTime: true, countBreakTime: 1 },
                { workDayId: 20, dayOfWeek: 'TUESDAY', startTime: '15:00', endTime: '18:00', breakTime: false, countBreakTime: 0 },
            ],
        } as any,

        {
            workScheduleId: 16,
            name: 'Standard Shif vwt',
            department: { departmentId: 27, name: 'Human Resources v323' },
            status: 'ACTIVE',
            days: [
                { workDayId: 17, dayOfWeek: 'MONDAY', startTime: '09:00', endTime: '18:00', breakTime: true, countBreakTime: 1 },
                { workDayId: 39, dayOfWeek: 'WEDNESDAY', startTime: '09:00', endTime: '18:00', breakTime: true, countBreakTime: 1 },
            ],
        } as any,

        {
            workScheduleId: 15,
            name: 'Standard Shif vwt',
            department: { departmentId: 24, name: 'Human Resources v31' },
            status: 'ACTIVE',
            days: [{ workDayId: 16, dayOfWeek: 'MONDAY', startTime: '09:00', endTime: '18:00', breakTime: false, countBreakTime: 0 }],
        } as any,

        {
            workScheduleId: 13,
            name: 'Standard Shift Updated',
            department: { departmentId: 17, name: 'Development Team v22' },
            status: 'ACTIVE',
            days: [
                { workDayId: 10, dayOfWeek: 'MONDAY', startTime: '16:00', endTime: '22:00', breakTime: false, countBreakTime: 0 },
                { workDayId: 11, dayOfWeek: 'FRIDAY', startTime: '12:00', endTime: '22:00', breakTime: false, countBreakTime: 0 },
                { workDayId: 12, dayOfWeek: 'SATURDAY', startTime: '15:00', endTime: '18:00', breakTime: false, countBreakTime: 0 },
                { workDayId: 13, dayOfWeek: 'SUNDAY', startTime: '15:00', endTime: '18:00', breakTime: false, countBreakTime: 0 },
            ],
        } as any,

        {
            workScheduleId: 31,
            name: 'Morning Shift',
            department: { departmentId: 1, name: 'Human Resources' },
            status: 'ACTIVE',
            days: [
                { workDayId: 61, dayOfWeek: 'MONDAY', startTime: '08:00', endTime: '16:00' },
                { workDayId: 62, dayOfWeek: 'TUESDAY', startTime: '08:00', endTime: '16:00' },
                { workDayId: 63, dayOfWeek: 'WEDNESDAY', startTime: '08:00', endTime: '16:00' },
            ],
        } as any,

        {
            workScheduleId: 32,
            name: 'Night Shift',
            department: { departmentId: 2, name: 'Operations' },
            status: 'ACTIVE',
            days: [
                { workDayId: 64, dayOfWeek: 'THURSDAY', startTime: '22:00', endTime: '06:00' },
                { workDayId: 65, dayOfWeek: 'FRIDAY', startTime: '22:00', endTime: '06:00' },
            ],
        } as any,

        {
            workScheduleId: 33,
            name: 'Weekend Coverage',
            department: { departmentId: 6, name: 'Logistics' },
            status: 'ACTIVE',
            days: [
                { workDayId: 66, dayOfWeek: 'SATURDAY', startTime: '09:00', endTime: '14:00' },
                { workDayId: 67, dayOfWeek: 'SUNDAY', startTime: '09:00', endTime: '14:00' },
            ],
        } as any,

        {
            workScheduleId: 34,
            name: 'Split Shift',
            department: { departmentId: 23, name: 'Data' },
            status: 'ACTIVE',
            days: [
                { workDayId: 68, dayOfWeek: 'MONDAY', startTime: '08:00', endTime: '12:00' },
                { workDayId: 69, dayOfWeek: 'MONDAY', startTime: '14:00', endTime: '18:00' },
            ],
        } as any,

        {
            workScheduleId: 35,
            name: 'Inactive - Legacy',
            department: { departmentId: 24, name: 'Human Resources v31' },
            status: 'INACTIVE',
            days: [{ workDayId: 70, dayOfWeek: 'TUESDAY', startTime: '10:00', endTime: '12:00' }],
        } as any,

        {
            workScheduleId: 36,
            name: 'Sales Shift',
            department: { departmentId: 9, name: 'Sales' },
            status: 'ACTIVE',
            days: [
                { workDayId: 71, dayOfWeek: 'MONDAY', startTime: '09:30', endTime: '18:30' },
                { workDayId: 72, dayOfWeek: 'WEDNESDAY', startTime: '09:30', endTime: '18:30' },
            ],
        } as any,

        {
            workScheduleId: 37,
            name: 'Support Shift',
            department: { departmentId: 25, name: 'Support' },
            status: 'ACTIVE',
            days: [
                { workDayId: 73, dayOfWeek: 'TUESDAY', startTime: '07:00', endTime: '15:00' },
                { workDayId: 74, dayOfWeek: 'THURSDAY', startTime: '07:00', endTime: '15:00' },
            ],
        } as any,

        {
            workScheduleId: 38,
            name: 'Finance Short',
            department: { departmentId: 3, name: 'Finance' },
            status: 'ACTIVE',
            days: [{ workDayId: 75, dayOfWeek: 'FRIDAY', startTime: '09:00', endTime: '13:00' }],
        } as any,

        {
            workScheduleId: 39,
            name: 'Engineering Core',
            department: { departmentId: 7, name: 'Engineering' },
            status: 'ACTIVE',
            days: [
                { workDayId: 76, dayOfWeek: 'MONDAY', startTime: '10:00', endTime: '19:00' },
                { workDayId: 77, dayOfWeek: 'TUESDAY', startTime: '10:00', endTime: '19:00' },
                { workDayId: 78, dayOfWeek: 'WEDNESDAY', startTime: '10:00', endTime: '19:00' },
            ],
        } as any,

        {
            workScheduleId: 40,
            name: 'QA Coverage',
            department: { departmentId: 8, name: 'QA' },
            status: 'ACTIVE',
            days: [{ workDayId: 79, dayOfWeek: 'THURSDAY', startTime: '11:00', endTime: '19:00' }],
        } as any,

        {
            workScheduleId: 41,
            name: 'Ops Rotation',
            department: { departmentId: 2, name: 'Operations' },
            status: 'ACTIVE',
            days: [
                { workDayId: 80, dayOfWeek: 'MONDAY', startTime: '06:00', endTime: '14:00' },
                { workDayId: 81, dayOfWeek: 'TUESDAY', startTime: '14:00', endTime: '22:00' },
            ],
        } as any,

        {
            workScheduleId: 42,
            name: 'Admin Standard',
            department: { departmentId: 32, name: 'Administration' },
            status: 'ACTIVE',
            days: [
                { workDayId: 82, dayOfWeek: 'MONDAY', startTime: '09:00', endTime: '18:00' },
                { workDayId: 83, dayOfWeek: 'FRIDAY', startTime: '09:00', endTime: '18:00' },
            ],
        } as any,
    ];

    const sortByIdDesc = (a: WorkScheduleResponse, b: WorkScheduleResponse) =>
        Number(b.workScheduleId ?? 0) - Number(a.workScheduleId ?? 0);

    function paginate<T>(items: T[], page: number, size: number) {
        const safePage = Math.max(0, Number(page ?? 0));
        const safeSize = Math.max(1, Number(size ?? 10));
        const start = safePage * safeSize;
        const end = start + safeSize;

        const totalElements = items.length;
        const totalPages = Math.max(1, Math.ceil(totalElements / safeSize));

        const pageInfo: PageResponse = {
            number: safePage,
            size: safeSize,
            totalElements,
            totalPages,
        };

        return { slice: items.slice(start, end), pageInfo };
    }

    function ensureNextIds() {
        const maxScheduleId = Math.max(...schedules.map(s => Number(s.workScheduleId ?? 0)), 0);
        const maxWorkDayId = Math.max(
            ...schedules.flatMap(s => (s.days ?? []).map(d => Number((d as any).workDayId ?? 0))),
            0
        );
        nextScheduleId = Math.max(nextScheduleId, maxScheduleId + 1);
        nextWorkDayId = Math.max(nextWorkDayId, maxWorkDayId + 1);
    }

    ensureNextIds();

    function getAllWorkSchedules(page: number, size: number) {
        const ordered = [...schedules].sort(sortByIdDesc);
        const { slice, pageInfo } = paginate(ordered, page, size);

        return [
            {
                content: slice,
                page: {
                    number: pageInfo.number,
                    size: pageInfo.size,
                    totalElements: pageInfo.totalElements,
                    totalPages: pageInfo.totalPages,
                },
            },
        ];
    }

    function getWorkScheduleById(workScheduleId: number): WorkScheduleResponse {
        const id = Number(workScheduleId);
        const found = schedules.find(s => Number(s.workScheduleId) === id);
        if (!found) {
            throw { status: 404, message: 'WorkSchedule no encontrado' };
        }
        return found;
    }

    function createWorkSchedule(req: WorkScheduleCreateRequest): WorkScheduleResponse {
        const created: WorkScheduleResponse = {
            workScheduleId: nextScheduleId++,
            name: (req as any)?.name ?? 'New schedule',
            status: 'ACTIVE',
            department: {
                departmentId: Number((req as any)?.departmentId ?? 0),
                name: `Department ${Number((req as any)?.departmentId ?? 0)}`,
            },
            days: ((req as any)?.days ?? []).map((d: any) => ({
                workDayId: nextWorkDayId++,
                dayOfWeek: d.dayOfWeek,
                startTime: d.startTime,
                endTime: d.endTime,
                breakTime: d.breakTime === true,
                countBreakTime: Number.isFinite(Number(d.countBreakTime)) ? Number(d.countBreakTime) : 0,
            })),
        } as any;

        schedules.unshift(created);
        return created;
    }

    function updateWorkSchedule(
        scheduleId: number,
        req: WorkScheduleUpdateRequest
    ): WorkScheduleResponse {
        const id = Number(scheduleId);
        const idx = schedules.findIndex(s => Number(s.workScheduleId) === id);
        if (idx === -1) {
            throw { status: 404, message: 'WorkSchedule no encontrado' };
        }

        const current = schedules[idx];

        const updated: WorkScheduleResponse = {
            ...current,
            name: (req as any)?.name ?? current.name,
            status: (req as any)?.status ?? current.status,
            department: {
                departmentId: Number((req as any)?.departmentId ?? (current as any)?.department?.departmentId ?? 0),
                name: Number((req as any)?.departmentId ?? 0) > 0
                    ? `Department ${Number((req as any)?.departmentId)}`
                    : ((current as any)?.department?.name ?? ''),
            },
            days: ((req as any)?.days ?? []).map((d: any) => ({
                workDayId: d.workDayId ?? nextWorkDayId++,
                dayOfWeek: d.dayOfWeek,
                startTime: d.startTime,
                endTime: d.endTime,
                breakTime: d.breakTime === true,
                countBreakTime: Number.isFinite(Number(d.countBreakTime)) ? Number(d.countBreakTime) : 0,
            })),
        } as any;

        schedules[idx] = updated;
        return updated;
    }

    function deleteWorkScheduleById(scheduleId: number): void {
        const id = Number(scheduleId);
        const idx = schedules.findIndex(s => Number(s.workScheduleId) === id);
        if (idx === -1) {
            throw { status: 404, message: 'WorkSchedule no encontrado' };
        }
        schedules.splice(idx, 1);
    }

    return {
        getAllWorkSchedules,
        getWorkScheduleById,
        createWorkSchedule,
        updateWorkSchedule,
        deleteWorkScheduleById,
    };
})();